module.exports = __webpack_public_path__ + "img/characterAnime2.e3f444fe.png";